module.exports = __webpack_public_path__ + "img/logo.f730979b.png";